// ============================================================================
// Doc Order — Encompass field map (ops-confirmed, July 2026).
// GENERATED from docorder-handoff/docorder/encompass-field-map.js — do not
// hand-edit IDs; regenerate via scratchpad gen-field-map.cjs if the handoff
// map is ever revised. Single source for the doc-order pull + P3 write-back
// (and the P3 encompass_writable_fields allowlist seed script).
// ⚠ 808.lastDisclosedCD = 'NEWHUD2.X1227' collides textually with 802e's
//   additionalOrigCredit 'NEWHUD.X1227' — different prefixes, both correct.
// ============================================================================

/** Loan-level field IDs (numeric Encompass IDs stay numbers, dotted IDs strings). */
export const DO_LOAN_FIELDS = {
  totalLoanAmount: 2,
  baseLoanAmount: 1109,
  vestingDescription: 1867,
  subjectPropertyState: 14,
  lenderCredit: 4794,
  cashToFromBorrower: 142,
  b1Marital: 52,
  b2Marital: 84,
  b1Sex: 4193,
  b2Sex: 4197,
  llcEntityName: 1859,
  llcEntityState: 1860,
  llcEntityOrgType: 1861,
  llcEntityEIN: 1862,
  settlementAgent: 610,
  settlementAgentName: 611,
  settlementAgentPhone: 615,
  settlementAgentEmail: 87,
  hazardInsuranceCompany: 'L252',
  hazardMonthlyPremium: 230,
  hazardAgentPhone: 'VEND.X163',
  hazardAgentEmail: 'VEND.X164',
  initialCdSentDate: 3977,
  initialGfeSentDate: 3148,
  piwIndicator: 4954,
  hazardEffectiveDate: null, // no Encompass field — AI-from-doc/manual
  hazardExpirationDate: null, // no Encompass field — AI-from-doc/manual
  dicCompany: 'VEND.X64',
  dicAgentName: 'VEND.X65',
  // Jennifer round 7: Line 1007 monthly premium; display annualizes ×12.
  dicMonthlyPremium: 1630,
  dicEffectiveDate: 'TBD',
  dicExpirationDate: 'TBD',
  dicPhone: 'VEND.X71',
  dicEmail: 'VEND.X73',
  loPayerBucket: 'Lender',
  encPaidBy: 'TBD',
  feeLastDisclosed: 'per-line — feeLineFields[line].lastDisclosedLE (NEWHUD2 X-series)',
  lenderCreditDisclosed: 'TBD',
  feeEncompassAmount: 'TBD',
  loanChannel: 2626,
  loCompensation: 'LO Profitability system',
  loCreditBalance: 'LO Profitability system',
  loanPrice: 'Product & Pricing section (Loan Center) — existing portal',
} as const;

export type FeeLineId = '803' | '804' | '805' | '806' | '807' | '808' | '809' | '810' | '811' | '812' | '813' | '814' | '815' | '816' | '817' | '818' | '801a' | '802e';

export interface FeeLineFieldSet {
  feeDescription?: string | number; payee?: string | number; paidToName?: string | number;
  borrowerDefault: string | number; sellerDefault: string | number;
  totalFee: string; feePercent: string; lastDisclosedLE: string; lastDisclosedCD: string;
  paidToType: string | number;
  borrowerFinanced: string; borrowerOwnFunds: string;
  borrowerPAC: string; borrowerPOC: string; borrowerTotal: string;
  sellerPAC: string; sellerPOC: string; sellerTotal: string;
  brokerPAC: string; brokerPOC: string; brokerTotal: string;
  lenderPAC: string; lenderPOC: string; lenderTotal: string;
  otherPAC: string; otherPOC: string; otherTotal: string;
  paidByBrokerLenderOther: string; section32PointsFees: string;
  aprBorrowerPaidOnly: string | number; sellerObligated: string; sellerObligatedAmt: string;
  bonaFideDiscount?: string; discountPercent?: string; additionalOrigCredit?: string;
}

/** §800 per-line field grid, lines 801a–818 (all ops-confirmed). */
export const DO_FEE_LINE_FIELDS: Record<FeeLineId, FeeLineFieldSet> = {
  '803': {
    feeDescription: 'NEWHUD2.X7',
    paidToName: 'NEWHUD2.X8',
    borrowerDefault: 'NEWHUD2.X9',
    sellerDefault: 'NEWHUD2.X10',
    totalFee: 'NEWHUD2.X1059',
    feePercent: 'NEWHUD2.X1060',
    lastDisclosedLE: 'NEWHUD2.X1061',
    lastDisclosedCD: 'NEWHUD2.X1062',
    paidToType: 'NEWHUD2.X1063',
    borrowerFinanced: 'NEWHUD2.X1065',
    borrowerOwnFunds: 'NEWHUD2.X1066',
    borrowerPAC: 'NEWHUD2.X1067',
    borrowerPOC: 'NEWHUD2.X1068',
    borrowerTotal: 'NEWHUD2.X1069',
    sellerPAC: 'NEWHUD2.X1070',
    sellerPOC: 'NEWHUD2.X1071',
    sellerTotal: 'NEWHUD2.X1072',
    brokerPAC: 'NEWHUD2.X1073',
    brokerPOC: 'NEWHUD2.X1074',
    brokerTotal: 'NEWHUD2.X1075',
    lenderPAC: 'NEWHUD2.X1076',
    lenderPOC: 'NEWHUD2.X1077',
    lenderTotal: 'NEWHUD2.X1078',
    otherPAC: 'NEWHUD2.X1079',
    otherPOC: 'NEWHUD2.X1080',
    otherTotal: 'NEWHUD2.X1081',
    paidByBrokerLenderOther: 'NEWHUD2.X1082',
    section32PointsFees: 'NEWHUD2.X1083',
    aprBorrowerPaidOnly: 'NEWHUD2.X70',
    sellerObligated: 'NEWHUD2.X1087',
    sellerObligatedAmt: 'NEWHUD2.X1088',
  },
  '804': {
    payee: 617,
    borrowerDefault: 641,
    sellerDefault: 581,
    totalFee: 'NEWHUD2.X1092',
    feePercent: 'NEWHUD2.X1093',
    lastDisclosedLE: 'NEWHUD2.X1094',
    lastDisclosedCD: 'NEWHUD2.X1095',
    paidToType: 'SYS.X256',
    borrowerFinanced: 'NEWHUD2.X1098',
    borrowerOwnFunds: 'NEWHUD2.X1099',
    borrowerPAC: 'NEWHUD2.X1100',
    borrowerPOC: 'NEWHUD2.X1101',
    borrowerTotal: 'NEWHUD2.X1102',
    sellerPAC: 'NEWHUD2.X1103',
    sellerPOC: 'NEWHUD2.X1104',
    sellerTotal: 'NEWHUD2.X1105',
    brokerPAC: 'NEWHUD2.X1106',
    brokerPOC: 'NEWHUD2.X1107',
    brokerTotal: 'NEWHUD2.X1108',
    lenderPAC: 'NEWHUD2.X1109',
    lenderPOC: 'NEWHUD2.X1110',
    lenderTotal: 'NEWHUD2.X1111',
    otherPAC: 'NEWHUD2.X1112',
    otherPOC: 'NEWHUD2.X1113',
    otherTotal: 'NEWHUD2.X1114',
    paidByBrokerLenderOther: 'NEWHUD2.X1115',
    section32PointsFees: 'NEWHUD2.X1116',
    aprBorrowerPaidOnly: 'SYS.X19',
    sellerObligated: 'NEWHUD2.X1120',
    sellerObligatedAmt: 'NEWHUD2.X1121',
  },
  '805': {
    payee: 624,
    borrowerDefault: 640,
    sellerDefault: 580,
    totalFee: 'NEWHUD2.X1125',
    feePercent: 'NEWHUD2.X1126',
    lastDisclosedLE: 'NEWHUD2.X1127',
    lastDisclosedCD: 'NEWHUD2.X1128',
    paidToType: 'SYS.X258',
    borrowerFinanced: 'NEWHUD2.X1131',
    borrowerOwnFunds: 'NEWHUD2.X1132',
    borrowerPAC: 'NEWHUD2.X1133',
    borrowerPOC: 'NEWHUD2.X1134',
    borrowerTotal: 'NEWHUD2.X1135',
    sellerPAC: 'NEWHUD2.X1136',
    sellerPOC: 'NEWHUD2.X1137',
    sellerTotal: 'NEWHUD2.X1138',
    brokerPAC: 'NEWHUD2.X1139',
    brokerPOC: 'NEWHUD2.X1140',
    brokerTotal: 'NEWHUD2.X1141',
    lenderPAC: 'NEWHUD2.X1142',
    lenderPOC: 'NEWHUD2.X1143',
    lenderTotal: 'NEWHUD2.X1144',
    otherPAC: 'NEWHUD2.X1145',
    otherPOC: 'NEWHUD2.X1146',
    otherTotal: 'NEWHUD2.X1147',
    paidByBrokerLenderOther: 'NEWHUD2.X1148',
    section32PointsFees: 'NEWHUD2.X1149',
    aprBorrowerPaidOnly: 'SYS.X20',
    sellerObligated: 'NEWHUD2.X1153',
    sellerObligatedAmt: 'NEWHUD2.X1154',
  },
  '806': {
    payee: 'L224',
    borrowerDefault: 336,
    sellerDefault: 565,
    totalFee: 'NEWHUD2.X1158',
    feePercent: 'NEWHUD2.X1159',
    lastDisclosedLE: 'NEWHUD2.X1160',
    lastDisclosedCD: 'NEWHUD2.X1161',
    paidToType: 'SYS.X268',
    borrowerFinanced: 'NEWHUD2.X1164',
    borrowerOwnFunds: 'NEWHUD2.X1165',
    borrowerPAC: 'NEWHUD2.X1166',
    borrowerPOC: 'NEWHUD2.X1167',
    borrowerTotal: 'NEWHUD2.X1168',
    sellerPAC: 'NEWHUD2.X1169',
    sellerPOC: 'NEWHUD2.X1170',
    sellerTotal: 'NEWHUD2.X1171',
    brokerPAC: 'NEWHUD2.X1172',
    brokerPOC: 'NEWHUD2.X1173',
    brokerTotal: 'NEWHUD2.X1174',
    lenderPAC: 'NEWHUD2.X1175',
    lenderPOC: 'NEWHUD2.X1176',
    lenderTotal: 'NEWHUD2.X1177',
    otherPAC: 'NEWHUD2.X1178',
    otherPOC: 'NEWHUD2.X1179',
    otherTotal: 'NEWHUD2.X1180',
    paidByBrokerLenderOther: 'NEWHUD2.X1181',
    section32PointsFees: 'NEWHUD2.X1182',
    aprBorrowerPaidOnly: 'SYS.X22',
    sellerObligated: 'NEWHUD2.X1186',
    sellerObligatedAmt: 'NEWHUD2.X1187',
  },
  '807': {
    payee: 'NEWHUD.X399',
    borrowerDefault: 'NEWHUD.X400',
    sellerDefault: 'NEWHUD.X781',
    totalFee: 'NEWHUD2.X1191',
    feePercent: 'NEWHUD2.X1192',
    lastDisclosedLE: 'NEWHUD2.X1193',
    lastDisclosedCD: 'NEWHUD2.X1194',
    paidToType: 'NEWHUD.X628',
    borrowerFinanced: 'NEWHUD2.X1197',
    borrowerOwnFunds: 'NEWHUD2.X1198',
    borrowerPAC: 'NEWHUD2.X1199',
    borrowerPOC: 'NEWHUD2.X1200',
    borrowerTotal: 'NEWHUD2.X1201',
    sellerPAC: 'NEWHUD2.X1202',
    sellerPOC: 'NEWHUD2.X1203',
    sellerTotal: 'NEWHUD2.X1204',
    brokerPAC: 'NEWHUD2.X1205',
    brokerPOC: 'NEWHUD2.X1206',
    brokerTotal: 'NEWHUD2.X1207',
    lenderPAC: 'NEWHUD2.X1208',
    lenderPOC: 'NEWHUD2.X1209',
    lenderTotal: 'NEWHUD2.X1210',
    otherPAC: 'NEWHUD2.X1211',
    otherPOC: 'NEWHUD2.X1212',
    otherTotal: 'NEWHUD2.X1213',
    paidByBrokerLenderOther: 'NEWHUD2.X1214',
    section32PointsFees: 'NEWHUD2.X1215',
    aprBorrowerPaidOnly: 'NEWHUD.X178',
    sellerObligated: 'NEWHUD2.X1219',
    sellerObligatedAmt: 'NEWHUD2.X1220',
  },
  '808': {
    feeDescription: 'NEWHUD.X126',
    payee: 'NEWHUD.X1050',
    borrowerDefault: 'NEWHUD.X136',
    sellerDefault: 'NEWHUD.X147',
    totalFee: 'NEWHUD2.X1224',
    feePercent: 'NEWHUD2.X1225',
    lastDisclosedLE: 'NEWHUD2.X1226',
    lastDisclosedCD: 'NEWHUD2.X1227',
    paidToType: 'NEWHUD.X189',
    borrowerFinanced: 'NEWHUD2.X1230',
    borrowerOwnFunds: 'NEWHUD2.X1231',
    borrowerPAC: 'NEWHUD2.X1232',
    borrowerPOC: 'NEWHUD2.X1233',
    borrowerTotal: 'NEWHUD2.X1234',
    sellerPAC: 'NEWHUD2.X1235',
    sellerPOC: 'NEWHUD2.X1236',
    sellerTotal: 'NEWHUD2.X1237',
    brokerPAC: 'NEWHUD2.X1238',
    brokerPOC: 'NEWHUD2.X1239',
    brokerTotal: 'NEWHUD2.X1240',
    lenderPAC: 'NEWHUD2.X1241',
    lenderPOC: 'NEWHUD2.X1242',
    lenderTotal: 'NEWHUD2.X1243',
    otherPAC: 'NEWHUD2.X1244',
    otherPOC: 'NEWHUD2.X1245',
    otherTotal: 'NEWHUD2.X1246',
    paidByBrokerLenderOther: 'NEWHUD2.X1247',
    section32PointsFees: 'NEWHUD2.X1248',
    aprBorrowerPaidOnly: 'NEWHUD.X179',
    sellerObligated: 'NEWHUD2.X1252',
    sellerObligatedAmt: 'NEWHUD2.X1253',
  },
  '809': {
    feeDescription: 'NEWHUD.X127',
    payee: 'NEWHUD.X1051',
    borrowerDefault: 'NEWHUD.X137',
    sellerDefault: 'NEWHUD.X148',
    totalFee: 'NEWHUD2.X1257',
    feePercent: 'NEWHUD2.X1258',
    lastDisclosedLE: 'NEWHUD2.X1259',
    lastDisclosedCD: 'NEWHUD2.X1260',
    paidToType: 'NEWHUD.X190',
    borrowerFinanced: 'NEWHUD2.X1263',
    borrowerOwnFunds: 'NEWHUD2.X1264',
    borrowerPAC: 'NEWHUD2.X1265',
    borrowerPOC: 'NEWHUD2.X1266',
    borrowerTotal: 'NEWHUD2.X1267',
    sellerPAC: 'NEWHUD2.X1268',
    sellerPOC: 'NEWHUD2.X1269',
    sellerTotal: 'NEWHUD2.X1270',
    brokerPAC: 'NEWHUD2.X1271',
    brokerPOC: 'NEWHUD2.X1272',
    brokerTotal: 'NEWHUD2.X1273',
    lenderPAC: 'NEWHUD2.X1274',
    lenderPOC: 'NEWHUD2.X1275',
    lenderTotal: 'NEWHUD2.X1276',
    otherPAC: 'NEWHUD2.X1277',
    otherPOC: 'NEWHUD2.X1278',
    otherTotal: 'NEWHUD2.X1279',
    paidByBrokerLenderOther: 'NEWHUD2.X1280',
    section32PointsFees: 'NEWHUD2.X1281',
    aprBorrowerPaidOnly: 'NEWHUD.X180',
    sellerObligated: 'NEWHUD2.X1285',
    sellerObligatedAmt: 'NEWHUD2.X1286',
  },
  '810': {
    feeDescription: 'NEWHUD.X128',
    payee: 'NEWHUD.X1052',
    borrowerDefault: 'NEWHUD.X138',
    sellerDefault: 'NEWHUD.X149',
    totalFee: 'NEWHUD2.X1290',
    feePercent: 'NEWHUD2.X1291',
    lastDisclosedLE: 'NEWHUD2.X1292',
    lastDisclosedCD: 'NEWHUD2.X1293',
    paidToType: 'NEWHUD.X191',
    borrowerFinanced: 'NEWHUD2.X1296',
    borrowerOwnFunds: 'NEWHUD2.X1297',
    borrowerPAC: 'NEWHUD2.X1298',
    borrowerPOC: 'NEWHUD2.X1299',
    borrowerTotal: 'NEWHUD2.X1300',
    sellerPAC: 'NEWHUD2.X1301',
    sellerPOC: 'NEWHUD2.X1302',
    sellerTotal: 'NEWHUD2.X1303',
    brokerPAC: 'NEWHUD2.X1304',
    brokerPOC: 'NEWHUD2.X1305',
    brokerTotal: 'NEWHUD2.X1306',
    lenderPAC: 'NEWHUD2.X1307',
    lenderPOC: 'NEWHUD2.X1308',
    lenderTotal: 'NEWHUD2.X1309',
    otherPAC: 'NEWHUD2.X1310',
    otherPOC: 'NEWHUD2.X1311',
    otherTotal: 'NEWHUD2.X1312',
    paidByBrokerLenderOther: 'NEWHUD2.X1313',
    section32PointsFees: 'NEWHUD2.X1314',
    aprBorrowerPaidOnly: 'NEWHUD.X181',
    sellerObligated: 'NEWHUD2.X1318',
    sellerObligatedAmt: 'NEWHUD2.X1319',
  },
  '811': {
    feeDescription: 'NEWHUD.X129',
    payee: 'NEWHUD.X1053',
    borrowerDefault: 'NEWHUD.X139',
    sellerDefault: 'NEWHUD.X150',
    totalFee: 'NEWHUD2.X1323',
    feePercent: 'NEWHUD2.X1324',
    lastDisclosedLE: 'NEWHUD2.X1325',
    lastDisclosedCD: 'NEWHUD2.X1326',
    paidToType: 'NEWHUD.X192',
    borrowerFinanced: 'NEWHUD2.X1329',
    borrowerOwnFunds: 'NEWHUD2.X1330',
    borrowerPAC: 'NEWHUD2.X1331',
    borrowerPOC: 'NEWHUD2.X1332',
    borrowerTotal: 'NEWHUD2.X1333',
    sellerPAC: 'NEWHUD2.X1334',
    sellerPOC: 'NEWHUD2.X1335',
    sellerTotal: 'NEWHUD2.X1336',
    brokerPAC: 'NEWHUD2.X1337',
    brokerPOC: 'NEWHUD2.X1338',
    brokerTotal: 'NEWHUD2.X1339',
    lenderPAC: 'NEWHUD2.X1340',
    lenderPOC: 'NEWHUD2.X1341',
    lenderTotal: 'NEWHUD2.X1342',
    otherPAC: 'NEWHUD2.X1343',
    otherPOC: 'NEWHUD2.X1344',
    otherTotal: 'NEWHUD2.X1345',
    paidByBrokerLenderOther: 'NEWHUD2.X1346',
    section32PointsFees: 'NEWHUD2.X1347',
    aprBorrowerPaidOnly: 'NEWHUD.X182',
    sellerObligated: 'NEWHUD2.X1351',
    sellerObligatedAmt: 'NEWHUD2.X1352',
  },
  '812': {
    feeDescription: 'NEWHUD.X130',
    payee: 'NEWHUD.X1054',
    borrowerDefault: 'NEWHUD.X140',
    sellerDefault: 'NEWHUD.X151',
    totalFee: 'NEWHUD2.X1356',
    feePercent: 'NEWHUD2.X1357',
    lastDisclosedLE: 'NEWHUD2.X1358',
    lastDisclosedCD: 'NEWHUD2.X1359',
    paidToType: 'NEWHUD.X193',
    borrowerFinanced: 'NEWHUD2.X1362',
    borrowerOwnFunds: 'NEWHUD2.X1363',
    borrowerPAC: 'NEWHUD2.X1364',
    borrowerPOC: 'NEWHUD2.X1365',
    borrowerTotal: 'NEWHUD2.X1366',
    sellerPAC: 'NEWHUD2.X1367',
    sellerPOC: 'NEWHUD2.X1368',
    sellerTotal: 'NEWHUD2.X1369',
    brokerPAC: 'NEWHUD2.X1370',
    brokerPOC: 'NEWHUD2.X1371',
    brokerTotal: 'NEWHUD2.X1372',
    lenderPAC: 'NEWHUD2.X1373',
    lenderPOC: 'NEWHUD2.X1374',
    lenderTotal: 'NEWHUD2.X1375',
    otherPAC: 'NEWHUD2.X1376',
    otherPOC: 'NEWHUD2.X1377',
    otherTotal: 'NEWHUD2.X1378',
    paidByBrokerLenderOther: 'NEWHUD2.X1379',
    section32PointsFees: 'NEWHUD2.X1380',
    aprBorrowerPaidOnly: 'NEWHUD.X183',
    sellerObligated: 'NEWHUD2.X1384',
    sellerObligatedAmt: 'NEWHUD2.X1385',
  },
  '813': {
    feeDescription: 369,
    payee: 'NEWHUD.X1055',
    borrowerDefault: 370,
    sellerDefault: 574,
    totalFee: 'NEWHUD2.X1389',
    feePercent: 'NEWHUD2.X1390',
    lastDisclosedLE: 'NEWHUD2.X1391',
    lastDisclosedCD: 'NEWHUD2.X1392',
    paidToType: 'SYS.X276',
    borrowerFinanced: 'NEWHUD2.X1395',
    borrowerOwnFunds: 'NEWHUD2.X1396',
    borrowerPAC: 'NEWHUD2.X1397',
    borrowerPOC: 'NEWHUD2.X1398',
    borrowerTotal: 'NEWHUD2.X1399',
    sellerPAC: 'NEWHUD2.X1400',
    sellerPOC: 'NEWHUD2.X1401',
    sellerTotal: 'NEWHUD2.X1402',
    brokerPAC: 'NEWHUD2.X1403',
    brokerPOC: 'NEWHUD2.X1404',
    brokerTotal: 'NEWHUD2.X1405',
    lenderPAC: 'NEWHUD2.X1406',
    lenderPOC: 'NEWHUD2.X1407',
    lenderTotal: 'NEWHUD2.X1408',
    otherPAC: 'NEWHUD2.X1409',
    otherPOC: 'NEWHUD2.X1410',
    otherTotal: 'NEWHUD2.X1411',
    paidByBrokerLenderOther: 'NEWHUD2.X1412',
    section32PointsFees: 'NEWHUD2.X1413',
    aprBorrowerPaidOnly: 'SYS.X30',
    sellerObligated: 'NEWHUD2.X1417',
    sellerObligatedAmt: 'NEWHUD2.X1418',
  },
  '814': {
    feeDescription: 371,
    payee: 'NEWHUD.X1056',
    borrowerDefault: 372,
    sellerDefault: 575,
    totalFee: 'NEWHUD2.X1422',
    feePercent: 'NEWHUD2.X1423',
    lastDisclosedLE: 'NEWHUD2.X1424',
    lastDisclosedCD: 'NEWHUD2.X1425',
    paidToType: 'SYS.X278',
    borrowerFinanced: 'NEWHUD2.X1428',
    borrowerOwnFunds: 'NEWHUD2.X1429',
    borrowerPAC: 'NEWHUD2.X1430',
    borrowerPOC: 'NEWHUD2.X1431',
    borrowerTotal: 'NEWHUD2.X1432',
    sellerPAC: 'NEWHUD2.X1433',
    sellerPOC: 'NEWHUD2.X1434',
    sellerTotal: 'NEWHUD2.X1435',
    brokerPAC: 'NEWHUD2.X1436',
    brokerPOC: 'NEWHUD2.X1437',
    brokerTotal: 'NEWHUD2.X1438',
    lenderPAC: 'NEWHUD2.X1439',
    lenderPOC: 'NEWHUD2.X1440',
    lenderTotal: 'NEWHUD2.X1441',
    otherPAC: 'NEWHUD2.X1442',
    otherPOC: 'NEWHUD2.X1443',
    otherTotal: 'NEWHUD2.X1444',
    paidByBrokerLenderOther: 'NEWHUD2.X1445',
    section32PointsFees: 'NEWHUD2.X1446',
    aprBorrowerPaidOnly: 'SYS.X31',
    sellerObligated: 'NEWHUD2.X1450',
    sellerObligatedAmt: 'NEWHUD2.X1451',
  },
  '815': {
    feeDescription: 348,
    payee: 'NEWHUD.X1057',
    borrowerDefault: 349,
    sellerDefault: 96,
    totalFee: 'NEWHUD2.X1455',
    feePercent: 'NEWHUD2.X1456',
    lastDisclosedLE: 'NEWHUD2.X1457',
    lastDisclosedCD: 'NEWHUD2.X1458',
    paidToType: 'SYS.X280',
    borrowerFinanced: 'NEWHUD2.X1461',
    borrowerOwnFunds: 'NEWHUD2.X1462',
    borrowerPAC: 'NEWHUD2.X1463',
    borrowerPOC: 'NEWHUD2.X1464',
    borrowerTotal: 'NEWHUD2.X1465',
    sellerPAC: 'NEWHUD2.X1466',
    sellerPOC: 'NEWHUD2.X1467',
    sellerTotal: 'NEWHUD2.X1468',
    brokerPAC: 'NEWHUD2.X1469',
    brokerPOC: 'NEWHUD2.X1470',
    brokerTotal: 'NEWHUD2.X1471',
    lenderPAC: 'NEWHUD2.X1472',
    lenderPOC: 'NEWHUD2.X1473',
    lenderTotal: 'NEWHUD2.X1474',
    otherPAC: 'NEWHUD2.X1475',
    otherPOC: 'NEWHUD2.X1476',
    otherTotal: 'NEWHUD2.X1477',
    paidByBrokerLenderOther: 'NEWHUD2.X1478',
    section32PointsFees: 'NEWHUD2.X1479',
    aprBorrowerPaidOnly: 'SYS.X32',
    sellerObligated: 'NEWHUD2.X1483',
    sellerObligatedAmt: 'NEWHUD2.X1484',
  },
  '816': {
    feeDescription: 931,
    payee: 'NEWHUD.X1058',
    borrowerDefault: 932,
    sellerDefault: 1345,
    totalFee: 'NEWHUD2.X1488',
    feePercent: 'NEWHUD2.X1489',
    lastDisclosedLE: 'NEWHUD2.X1490',
    lastDisclosedCD: 'NEWHUD2.X1491',
    paidToType: 'SYS.X282',
    borrowerFinanced: 'NEWHUD2.X1494',
    borrowerOwnFunds: 'NEWHUD2.X1495',
    borrowerPAC: 'NEWHUD2.X1496',
    borrowerPOC: 'NEWHUD2.X1497',
    borrowerTotal: 'NEWHUD2.X1498',
    sellerPAC: 'NEWHUD2.X1499',
    sellerPOC: 'NEWHUD2.X1500',
    sellerTotal: 'NEWHUD2.X1501',
    brokerPAC: 'NEWHUD2.X1502',
    brokerPOC: 'NEWHUD2.X1503',
    brokerTotal: 'NEWHUD2.X1504',
    lenderPAC: 'NEWHUD2.X1505',
    lenderPOC: 'NEWHUD2.X1506',
    lenderTotal: 'NEWHUD2.X1507',
    otherPAC: 'NEWHUD2.X1508',
    otherPOC: 'NEWHUD2.X1509',
    otherTotal: 'NEWHUD2.X1510',
    paidByBrokerLenderOther: 'NEWHUD2.X1511',
    section32PointsFees: 'NEWHUD2.X1512',
    aprBorrowerPaidOnly: 'SYS.X33',
    sellerObligated: 'NEWHUD2.X1516',
    sellerObligatedAmt: 'NEWHUD2.X1517',
  },
  '817': {
    feeDescription: 1390,
    payee: 'NEWHUD.X1059',
    borrowerDefault: 1009,
    sellerDefault: 6,
    totalFee: 'NEWHUD2.X1521',
    feePercent: 'NEWHUD2.X1522',
    lastDisclosedLE: 'NEWHUD2.X1523',
    lastDisclosedCD: 'NEWHUD2.X1524',
    paidToType: 'SYS.X284',
    borrowerFinanced: 'NEWHUD2.X1527',
    borrowerOwnFunds: 'NEWHUD2.X1528',
    borrowerPAC: 'NEWHUD2.X1529',
    borrowerPOC: 'NEWHUD2.X1530',
    borrowerTotal: 'NEWHUD2.X1531',
    sellerPAC: 'NEWHUD2.X1532',
    sellerPOC: 'NEWHUD2.X1533',
    sellerTotal: 'NEWHUD2.X1534',
    brokerPAC: 'NEWHUD2.X1535',
    brokerPOC: 'NEWHUD2.X1536',
    brokerTotal: 'NEWHUD2.X1537',
    lenderPAC: 'NEWHUD2.X1538',
    lenderPOC: 'NEWHUD2.X1539',
    lenderTotal: 'NEWHUD2.X1540',
    otherPAC: 'NEWHUD2.X1541',
    otherPOC: 'NEWHUD2.X1542',
    otherTotal: 'NEWHUD2.X1543',
    paidByBrokerLenderOther: 'NEWHUD2.X1544',
    section32PointsFees: 'NEWHUD2.X1545',
    aprBorrowerPaidOnly: 'SYS.X34',
    sellerObligated: 'NEWHUD2.X1549',
    sellerObligatedAmt: 'NEWHUD2.X1550',
  },
  '818': {
    feeDescription: 'NEWHUD.X1291',
    payee: 'NEWHUD.X1292',
    borrowerDefault: 'NEWHUD.X1293',
    sellerDefault: 'NEWHUD.X1294',
    totalFee: 'NEWHUD2.X1554',
    feePercent: 'NEWHUD2.X1555',
    lastDisclosedLE: 'NEWHUD2.X1556',
    lastDisclosedCD: 'NEWHUD2.X1557',
    paidToType: 'NEWHUD.X1298',
    borrowerFinanced: 'NEWHUD2.X1560',
    borrowerOwnFunds: 'NEWHUD2.X1561',
    borrowerPAC: 'NEWHUD2.X1562',
    borrowerPOC: 'NEWHUD2.X1563',
    borrowerTotal: 'NEWHUD2.X1564',
    sellerPAC: 'NEWHUD2.X1565',
    sellerPOC: 'NEWHUD2.X1566',
    sellerTotal: 'NEWHUD2.X1567',
    brokerPAC: 'NEWHUD2.X1568',
    brokerPOC: 'NEWHUD2.X1569',
    brokerTotal: 'NEWHUD2.X1570',
    lenderPAC: 'NEWHUD2.X1571',
    lenderPOC: 'NEWHUD2.X1572',
    lenderTotal: 'NEWHUD2.X1573',
    otherPAC: 'NEWHUD2.X1574',
    otherPOC: 'NEWHUD2.X1575',
    otherTotal: 'NEWHUD2.X1576',
    paidByBrokerLenderOther: 'NEWHUD2.X1577',
    section32PointsFees: 'NEWHUD2.X1578',
    aprBorrowerPaidOnly: 'NEWHUD.X1297',
    sellerObligated: 'NEWHUD2.X1582',
    sellerObligatedAmt: 'NEWHUD2.X1583',
  },
  '801a': {
    feeDescription: 388,
    borrowerDefault: 454,
    sellerDefault: 559,
    totalFee: 'NEWHUD2.X300',
    feePercent: 'NEWHUD2.X301',
    lastDisclosedLE: 'NEWHUD2.X302',
    lastDisclosedCD: 'NEWHUD2.X303',
    paidToName: 'NEWHUD2.X104',
    paidToType: 'SYS.X252',
    borrowerFinanced: 'NEWHUD2.X306',
    borrowerOwnFunds: 'NEWHUD2.X307',
    borrowerPAC: 'NEWHUD2.X308',
    borrowerPOC: 'NEWHUD2.X309',
    borrowerTotal: 'NEWHUD2.X310',
    sellerPAC: 'NEWHUD2.X311',
    sellerPOC: 'NEWHUD2.X312',
    sellerTotal: 'NEWHUD2.X313',
    brokerPAC: 'NEWHUD2.X314',
    brokerPOC: 'NEWHUD2.X315',
    brokerTotal: 'NEWHUD2.X316',
    lenderPAC: 'NEWHUD2.X317',
    lenderPOC: 'NEWHUD2.X318',
    lenderTotal: 'NEWHUD2.X319',
    otherPAC: 'NEWHUD2.X320',
    otherPOC: 'NEWHUD2.X321',
    otherTotal: 'NEWHUD2.X322',
    paidByBrokerLenderOther: 'NEWHUD2.X323',
    section32PointsFees: 'NEWHUD2.X324',
    aprBorrowerPaidOnly: 'SYS.X17',
    sellerObligated: 'NEWHUD2.X328',
    sellerObligatedAmt: 'NEWHUD2.X329',
  },
  '802e': {
    bonaFideDiscount: 'NEWHUD.X1067',
    discountPercent: 'NEWHUD.X1150',
    additionalOrigCredit: 'NEWHUD.X1227',
    borrowerDefault: 'NEWHUD.X1151',
    sellerDefault: 'NEWHUD.X1152',
    totalFee: 'NEWHUD2.X927',
    feePercent: 'NEWHUD2.X928',
    lastDisclosedLE: 'NEWHUD2.X929',
    lastDisclosedCD: 'NEWHUD2.X930',
    paidToName: 'NEWHUD2.X111',
    paidToType: 'NEWHUD.X1178',
    borrowerFinanced: 'NEWHUD2.X933',
    borrowerOwnFunds: 'NEWHUD2.X934',
    borrowerPAC: 'NEWHUD2.X935',
    borrowerPOC: 'NEWHUD2.X936',
    borrowerTotal: 'NEWHUD2.X937',
    sellerPAC: 'NEWHUD2.X938',
    sellerPOC: 'NEWHUD2.X939',
    sellerTotal: 'NEWHUD2.X940',
    brokerPAC: 'NEWHUD2.X941',
    brokerPOC: 'NEWHUD2.X942',
    brokerTotal: 'NEWHUD2.X943',
    lenderPAC: 'NEWHUD2.X944',
    lenderPOC: 'NEWHUD2.X945',
    lenderTotal: 'NEWHUD2.X946',
    otherPAC: 'NEWHUD2.X947',
    otherPOC: 'NEWHUD2.X948',
    otherTotal: 'NEWHUD2.X949',
    paidByBrokerLenderOther: 'NEWHUD2.X950',
    section32PointsFees: 'NEWHUD2.X951',
    aprBorrowerPaidOnly: 'NEWHUD.X1177',
    sellerObligated: 'NEWHUD2.X955',
    sellerObligatedAmt: 'NEWHUD2.X956',
  },
};

/** Misc lines usable for manual-fee assignment at push time (ops #14). */
export const DO_MANUAL_FEE_LINES: FeeLineId[] = ['808', '809', '810', '811', '812', '813', '814', '815', '816', '817', '818'];

/**
 * Doc-order disposition → Encompass payer-bucket mapping (ops #13):
 * Borrower+PAC → borrowerPAC · Borrower+POC → borrowerPOC ·
 * LO/Lendwise+POC → lenderPOC (LO maps to the Lender bucket) ·
 * LO/Lendwise+PAC+reimburse → borrowerPAC (reimbursement settles via Banker Recon).
 */
export const DO_LO_PAYER_BUCKET = 'Lender' as const;
